import { useContext } from "react";
import AdminContext from "../contexts/AdminProvider";

const useAdmin = () => {
  return useContext(AdminContext);
};

export default useAdmin;
